<template>
  <div class="markdown-content" v-html="renderedHtml"></div>
</template>

<script>
import { marked } from 'marked';

const renderer = new marked.Renderer();
renderer.link = function(tokenOrHref, title, text) {
  let href = typeof tokenOrHref === 'object' ? tokenOrHref.href : tokenOrHref;
  let linkTitle = typeof tokenOrHref === 'object' ? tokenOrHref.title : title;
  let linkText = typeof tokenOrHref === 'object' ? tokenOrHref.text : text;
  const titleAttr = linkTitle ? ` title="${linkTitle}"` : '';
  const isExternal = /^https?:\/\//i.test(href) || href.startsWith('mailto:');
  const targetAttr = isExternal ? ' target="_blank" rel="noopener noreferrer"' : '';
  return `<a href="${href}"${titleAttr}${targetAttr}>${linkText}</a>`;
};

marked.setOptions({
  renderer,
  gfm: true,
  breaks: true,
});

export default {
  name: 'MarkdownRenderer',
  props: {
    content: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    renderedHtml() {
      if (!this.content) return '';
      
      // Interpolate any $store.state.* expressions in the markdown string
      const interpolated = this.content.replace(/\$store\.state\.([a-zA-Z0-9_.]+)/g, (match, path) => {
        const keys = path.split('.');
        let val = this.$store?.state;
        for (const key of keys) {
          if (val && typeof val === 'object') {
            val = val[key];
          } else {
            val = undefined;
            break;
          }
        }
        return val !== undefined ? val : match;
      });

      if (this.inline) {
        return marked.parseInline(interpolated);
      }
      return marked.parse(interpolated);
    }
  }
};
</script>

<style lang="scss">
.markdown-content {
  line-height: 1.35;

  p {
    margin-top: 0;
    margin-bottom: 0.65em;
    line-height: 1.35;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: inherit;
    text-decoration: underline;
    font-weight: bold;
  }
}
</style>
